export default __webpack_public_path__ + "static/media/news-list-bg.319692e8.svg";